var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Route as RouterRoute } from 'react-router-dom';
import qs from 'qs';
import { useMemo } from 'react';
import { memoize } from 'lodash';
import { useCheckForUpdates } from '../hooks/useCheckForUpdates';
export function renderRoutes(routes) {
    return routes.map(function (route) {
        return (jsx(RouterRoute, { key: route.path, path: route.path, component: wrapView(route.view), exact: route.options.exact }));
    });
}
var wrapView = memoize(function (View) {
    return function (props) {
        var mergedProps = useMemo(function () {
            var query = props.location.search
                ? qs.parse(props.location.search.substring(1))
                : {};
            return __assign(__assign({}, props), { match: __assign(__assign({}, props.match), { params: __assign(__assign({}, props.match.params), query) }) });
        }, [props]);
        useCheckForUpdates();
        return jsx(View, __assign({}, mergedProps));
    };
});
//# sourceMappingURL=renderRoutes.js.map